import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import CodeSelectBox from "../../components/common/CodeSelectBox";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import TopBoxDiv from "../../components/common/TopBoxDiv";
import { useMenuAuthInfo, useMultiLang } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import MessageDialog from "../../components/common/MessageDialog";

const UnitCodeManagementEditPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const menuAuthInfo = useMenuAuthInfo();

  const [distance, setDistance] = useState("");
  const [temperature, setTemperature] = useState("");
  const [pressure, setPressure] = useState("");

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const sbDistance = [
    { code: "", codeDesc: t("L0744") },
    ...useMultiLang("DISTANCE"),
  ];
  const sbTemperature = [
    { code: "", codeDesc: t("L0446") },
    ...useMultiLang("TEMPERATURE"),
  ];
  const sbPressure = [
    { code: "", codeDesc: t("L0447") },
    ...useMultiLang("PRESSURE"),
  ];

  const handleDistanceChange = (e) => {
    setDistance(e.target.value);
  };

  const handleTemperatureChange = (e) => {
    setTemperature(e.target.value);
  };

  const handlePressureChange = (e) => {
    setPressure(e.target.value);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSubmit = () => {
    if (!validate()) {
      return;
    }

    api
      .post("/manage/unitcode/add", {
        distance: distance,
        temperature: temperature,
        pressure: pressure,
      })
      .then(() => {
        navigate(-1);
      })
      .catch((error) => {
        if (error.response.data.result == "1") {
          setIsDialogOpen(true);
        }
      });
  };

  const handleDupConfirm = () => {
    setIsDialogOpen(false);
  };

  const [errors, setErrors] = useState({
    validTemperature: "",
  });

  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!temperature) {
      tempErrors.validTemperature = "Code Type is required.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0462")]}></BreadCrumbDiv>

      <InputWrapDiv>
        <TopBoxDiv value={"Unit Code Reg"}></TopBoxDiv>

        <table>
          <tbody>
            <tr>
              <th>{t("L0744")}</th>
              <td>
                <CodeSelectBox
                  value={distance}
                  codes={sbDistance}
                  onChange={handleDistanceChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="96%"
                  style={{
                    backgroundColor: "#f6f3f2",
                  }}
                />
              </td>
            </tr>
            <tr>
              <th>
                {t("L0446")} *
                {errors.validTemperature && (
                  <>
                    <br />
                    <span style={{ color: "red", fontSize: "10px" }}>
                      {errors.validTemperature}
                    </span>
                  </>
                )}
              </th>
              <td>
                <CodeSelectBox
                  value={temperature}
                  codes={sbTemperature}
                  onChange={handleTemperatureChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="96%"
                  style={{
                    backgroundColor: "#f6f3f2",
                  }}
                />
              </td>
            </tr>
            <tr>
              <th>{t("L0447")}</th>
              <td>
                <CodeSelectBox
                  value={pressure}
                  codes={sbPressure}
                  onChange={handlePressureChange}
                  isCodeVisible={false}
                  multiple={false}
                  width="96%"
                  style={{
                    backgroundColor: "#f6f3f2",
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </InputWrapDiv>

      <ButtonWrapDiv className="btn_bottom">
        {menuAuthInfo.reg && (
          <FunctionButton
            className="big"
            value={t("L0659")}
            onClick={handleSubmit}
          ></FunctionButton>
        )}
        <FunctionButton
          className="big bg_gray"
          value={t("L0005")}
          onClick={handleCancel}
        ></FunctionButton>
      </ButtonWrapDiv>

      {isDialogOpen && (
        <MessageDialog title={t("L0339")} message={t("L0124")}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleDupConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default UnitCodeManagementEditPage;
